<ng-container *ngIf="linksMap$ | async as linksMap">
  <ng-container *ngIf="linksMap.size > 0">
    <dcp-text-links
      [links]="linksMap.get(checkoutLegalLinksNode)"
      class="body--xs"></dcp-text-links>
  </ng-container>
</ng-container>
